import * as React from 'react';
import { convertRGBAtoColorString } from '../../utils/ui';
import { sneCustomColors } from '../../drawing/constants';

interface SNEColorSampleBoxProps {
  readonly textColorIndex: number;
  readonly backgroundColorIndex: number;
}

const colorSampleBoxContainerStyle: React.CSSProperties = {
  height: '71px',
  width: '269px',
  boxSizing: 'border-box',
  border: 'solid #000 1px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const sampleBoxStyle: React.CSSProperties = {
  boxSizing: 'border-box',
  width: '249px',
  height: '52px',
  border: 'solid #676767 1px',
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '1em',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const SNEColorSampleBox: React.SFC<SNEColorSampleBoxProps> = React.memo((props) => {
  const { textColorIndex, backgroundColorIndex } = props;
  const sampleBoxAdditionalStyle: React.CSSProperties = {};

  const colors = sneCustomColors['out'];
  if (colors === undefined) {
    throw new Error('Undefined color.');
  }

  sampleBoxAdditionalStyle.backgroundColor =
    convertRGBAtoColorString(colors[backgroundColorIndex]);
  sampleBoxAdditionalStyle.color =
    convertRGBAtoColorString(colors[textColorIndex]);

  return (
    <div style={colorSampleBoxContainerStyle}>
      <div style={{ ...sampleBoxStyle, ...sampleBoxAdditionalStyle }}>
        サンプルテキスト
      </div>
    </div>
  );
});

export default SNEColorSampleBox;
